// Admin-enabled payment rails, fetched once per session and shared by every
// PaymentMarks instance (currently the footer). Until the request resolves
// the list is empty, so nothing is advertised speculatively.
import { onMounted, ref } from 'vue';
import { fetchPaymentMethods, type PaymentMethod } from '../api/cms';

const methods = ref<PaymentMethod[]>([]);
const loaded = ref(false);
let fetching: Promise<void> | null = null;

function load(): Promise<void> {
  if (!fetching) {
    fetching = fetchPaymentMethods()
      .then((list) => {
        // The CMS answer is untrusted at this edge: anything but a list means no marks.
        methods.value = Array.isArray(list) ? list : [];
      })
      .catch(() => {
        /* no CMS answer → no marks */
      })
      .finally(() => {
        loaded.value = true;
      });
  }
  return fetching;
}

export function usePaymentMethods() {
  onMounted(() => {
    if (!loaded.value) void load();
  });
  return { methods, loaded };
}
